module.exports = __webpack_public_path__ + "img/fcImg.d6504f2d.png";